module.exports = __webpack_public_path__ + "static/img/banner-image.0f077f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner-image.png
// module id = N4c2
// module chunks = 1